import React from 'react';
import { SettingsNavHeader, SettingsNavOption } from '@/components/common/residents/mobile/SettingsNavHeader';
import { EVENTS_COLORS } from '@/constants/residents/mobile/eventsColors';
import { eventStrings } from '@/constants/residents/strings';

export type EventTabType = 'upcoming' | 'past';

const TAB_OPTIONS: SettingsNavOption<EventTabType>[] = [
  {
    key: 'upcoming',
    title: eventStrings.tabs.upcoming,
    description: eventStrings.tabDescriptions.upcoming,
    activeColor: EVENTS_COLORS.navHeaderBackground,
  },
  {
    key: 'past',
    title: eventStrings.tabs.past,
    description: eventStrings.tabDescriptions.past,
    activeColor: EVENTS_COLORS.navHeaderPastBackground,
  },
];

interface EventsNavHeaderProps {
  selectedTab: EventTabType;
  onTabChange: (tab: EventTabType) => void;
}

/**
 * Mobile Events Nav Header
 * Expandable accordion with tabs for Upcoming and Past events
 * Uses the reusable SettingsNavHeader component
 */
export const EventsNavHeader: React.FC<EventsNavHeaderProps> = ({
  selectedTab,
  onTabChange,
}) => {
  return (
    <SettingsNavHeader
      options={TAB_OPTIONS}
      selectedKey={selectedTab}
      onSelect={onTabChange}
      activeColor={EVENTS_COLORS.navHeaderBackground}
      cardBackgroundColor={EVENTS_COLORS.cardBackground}
      textPrimaryColor={EVENTS_COLORS.textPrimary}
      textMutedColor={EVENTS_COLORS.textSecondary}
    />
  );
};

export default EventsNavHeader;
